import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'src/components/ui/accordion';
import React from 'react';
import { clsx } from 'clsx';
import { CheckIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/CheckIcon/CheckIcon';
import { AddItemIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIcon';
import { DeleteKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/delete/DeleteKnowledgeBaseIntegrationModal/DeleteKnowledgeBaseIntegrationModal';
import { EditKnowledgeBaseIntegrationModal } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseIntegrationModal/EditKnowledgeBaseIntegrationModal';
import { AddFreshdeskTicketsPopup } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/FreshdeskTicketsAccordion/AddFreshdeskTicketsPopup/AddFreshdeskTicketsPopup';
import { AddItemIconDisabled } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIconDisabled';

export const FreshdeskTicketsAccordion = ({
  item = null,
  isButtonsDisabled = false,
  knowledgeBase,
}) => {
  const [value, setValue] = React.useState('');
  const disabled = !item;

  return (
    <div className={clsx('w-full flex flex-row items-start gap-5')}>
      <div className={'pt-5'}>
        <CheckIcon className={clsx(!disabled ? 'visible' : 'invisible')} />
      </div>
      <Accordion
        value={value}
        onValueChange={setValue}
        type="single"
        className="w-full max-w-[455px] min-w-[455px]"
        collapsible={true}
        disabled={disabled}
      >
        <AccordionItem
          value="new-card"
          className={clsx(
            'group border border-[#B8C1C633] rounded-sm-5 bg-white transition-shadow shadow-none',
            !disabled && 'hover:shadow-[0_2px_2px_rgba(0,0,0,0.25)]',
          )}
        >
          <AccordionTrigger hideDefaultIcon className="py-2.5 px-5 cursor-default">
            <div className="flex items-center justify-between w-full">
              <div className={'flex flex-row gap-[7px] w-full'}>
                <div className={'pt-[3px]'}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_28642_18323)">
                      <path
                        d="M7.47655 0.0010372H13.11C13.3589 -0.000964776 13.6058 0.0466247 13.8361 0.141029C14.0665 0.235434 14.2757 0.374764 14.4516 0.550891C14.6276 0.727017 14.7667 0.936415 14.8608 1.16687C14.9549 1.39732 15.0023 1.64421 15 1.89315V7.52447C15 11.6546 11.6536 15.001 7.52343 15.001H7.48077C6.49867 15.0019 5.52603 14.8092 4.61845 14.4339C3.71086 14.0587 2.88613 13.5083 2.19138 12.8141C1.49664 12.12 0.945511 11.2957 0.5695 10.3884C0.19349 9.48116 -3.11713e-05 8.50868 3.76598e-09 7.52658C3.76598e-09 3.38471 3.34078 0.0436934 7.47655 0.0010372Z"
                        fill="#05050D"
                      />
                      <path
                        d="M7.49881 3.3418C5.60211 3.3418 4.06445 4.8793 4.06445 6.77633V9.11164C4.07805 9.73671 4.58146 10.2402 5.2065 10.2537H6.17794V7.57109H4.86551V6.82109C4.94519 5.40875 6.11396 4.30391 7.52881 4.30391C8.94366 4.30391 10.1096 5.40664 10.1893 6.82109V7.57109H8.85811V10.2556H9.7358V10.2983C9.72643 10.8781 9.25887 11.3459 8.68117 11.353H7.63286C7.54756 11.353 7.45381 11.3956 7.45381 11.4807C7.45587 11.5275 7.4754 11.5719 7.50854 11.605C7.54169 11.6382 7.58604 11.6577 7.63286 11.6598H8.6875C9.43863 11.6551 10.0463 11.0473 10.051 10.2962V10.2109C10.3019 10.1543 10.5259 10.0136 10.6856 9.81196C10.8453 9.61037 10.9311 9.36014 10.9287 9.10296V6.82109C10.9714 4.88656 9.43722 3.34391 7.49436 3.34391L7.49881 3.3418Z"
                        fill="#F1F7F6"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_28642_18323">
                        <rect
                          width="15"
                          height="15"
                          fill="white"
                          transform="translate(0 0.000976562)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className={'flex flex-row w-full justify-between'}>
                  <div className={'text-start'}>
                    <p className={'text-ebony text-sm font-semibold'}>Freshdesk tickets</p>
                    <p className={'text-ebony_opacity_30 text-base-xs font-medium'}>
                      Teach your AI from solved tickets
                    </p>
                  </div>
                  {item && (
                    <div className={'flex items-center gap-7.5'}>
                      <div className={'cursor-pointer opacity-50 hover:opacity-100'}>
                        <EditKnowledgeBaseIntegrationModal
                          knowledgeBaseId={knowledgeBase.id}
                          trigger={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 15 15"
                              fill="none"
                            >
                              <path
                                d="M1.66667 13.3306H2.845L10.6067 5.55634L9.42833 4.37609L1.66667 12.1504V13.3306ZM15 15H0V11.4584L11.1958 0.244385C11.3521 0.0879054 11.564 0 11.785 0C12.006 0 12.2179 0.0879054 12.3742 0.244385L14.7317 2.60572C14.8879 2.76224 14.9757 2.97451 14.9757 3.19584C14.9757 3.41717 14.8879 3.62944 14.7317 3.78597L5.2025 13.3306H15V15ZM10.6067 3.19584L11.785 4.37609L12.9633 3.19584L11.785 2.01559L10.6067 3.19584Z"
                                fill="#05050D"
                              />
                            </svg>
                          }
                          item={{ ...item, data: item }}
                        />
                      </div>
                      <div
                        className={
                          'cursor-pointer opacity-50 hover:opacity-100 transition [&_svg>path]:hover:fill-delete'
                        }
                      >
                        <DeleteKnowledgeBaseIntegrationModal
                          knowledgeBaseId={knowledgeBase.id}
                          item={{ ...item, data: item }}
                          trigger={
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="19"
                              viewBox="0 0 17 19"
                              fill="none"
                            >
                              <path
                                d="M1.9375 18V3.83333H1V1.94444H5.6875V1H11.3125V1.94444H16V3.83333H15.0625V18H1.9375ZM3.8125 16.1111H13.1875V3.83333H3.8125V16.1111ZM5.6875 14.2222H7.5625V5.72222H5.6875V14.2222ZM9.4375 14.2222H11.3125V5.72222H9.4375V14.2222Z"
                                fill="#05050D"
                                stroke="white"
                                strokeWidth="0.2"
                              />
                            </svg>
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="px-5 pb-0 max-w-[454px]"></AccordionContent>
        </AccordionItem>
      </Accordion>
      <div
        className={clsx(
          'group pt-3.5 hover:cursor-pointer',
          !disabled && 'invisible pointer-events-none',
        )}
      >
        {isButtonsDisabled ? (
          <AddItemIconDisabled />
        ) : (
          <AddFreshdeskTicketsPopup
            disabled={isButtonsDisabled}
            knowledgeBaseId={knowledgeBase.id}
            trigger={<AddItemIcon />}
          />
        )}
      </div>
    </div>
  );
};
